// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yAAJ","left":"styles_left__3seiz","desktopActions":"styles_desktopActions__21SFJ","title":"styles_title__3HYwB"};